module.exports = __webpack_public_path__ + "static/DigitalTransformation625-e45e265b9062413e5aae4a25bb3dde48.png";